import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { Colors, Shapes } from 'src/components/theme'
import { AlphamapLogoThrobber } from 'src/components/alphamap-logo/throbber'

const LoadingWrapper = styled.div`
  padding: ${Shapes.spacing[4]}px;
`
const LoadingContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${Shapes.spacing[2]}px;
  padding: ${Shapes.spacing[6]}px;
  align-items: center;
  background-color: ${Colors.bgLight};
  border-radius: ${Shapes.borderRadius}px;
`
type LoadingProps = {
  hideLabel?: boolean
  label?: string
  height?: number
}
export const Loading = (props: LoadingProps) => {
  const { label, hideLabel, height = 240 } = props
  return (
    <LoadingWrapper>
      <LoadingContent style={{ minHeight: height }}>
        <AlphamapLogoThrobber />
        {!hideLabel && (
          <Typography variant="title2" color={Colors.textLight}>
            {label ||
              'Please allow up to 5 mins for results to build. Feel free to leave this page and come back later.'}
          </Typography>
        )}
      </LoadingContent>
    </LoadingWrapper>
  )
}
